import {ENDPOINTS} from 'constants/endpoints';
import {apiConfig} from 'libs/api/api';
import {retryAxiosError} from 'libs/retryError/retryError';
import {flags} from 'libs/rollout';
import {logWithSentry} from 'libs/sentry/sentry';

/**
 * sends request to validate primer order and create order id
 */
export const validateOrder = async (
    paymentMethod: string,
    token: string,
    vaultOnSuccess: boolean,
) => {
    try {
        const data = {
            clientToken: token,
            paymentMethod,
            vaultOnSuccess,
        };

        const isFlagEnabled =
            __BUILD_TYPE__ === 'desktop'
                ? flags.dPrimerRetryMechanism.isEnabled()
                : flags.mPrimerRetryMechanism.isEnabled();

        return isFlagEnabled
            ? retryAxiosError(
                  async attempt =>
                      await apiConfig.instanceGusaBackend({
                          data,
                          method: 'POST',
                          params: {attempt},
                          url: ENDPOINTS.PRIMER_PREVALIDATE_ORDER,
                      }),
              )
            : apiConfig.instanceGusaBackend({
                  data,
                  method: 'POST',
                  url: ENDPOINTS.PRIMER_PREVALIDATE_ORDER,
              });
    } catch (e) {
        logWithSentry(e, 'Cannot prevalidate Primer order');
        throw e;
    }
};
